module.exports = __webpack_public_path__ + "static/media/README.2f7edbd7.md";